import { db } from "app/firebaseInit";
import {
    collection,
    query,
    where,
    orderBy,
    limit,
    getDocs,
    startAfter,
} from "firebase/firestore";

const auditCollection = collection(db, "auditLogs");

export const fetchAuditLogs = async ({
    action,
    entityType,
    userId,
    fromDate,
    toDate,
    lastDoc,
    pageSize = 30,
}) => {
    let q = query(
        auditCollection,
        orderBy("createdAt", "desc"),
        limit(pageSize)
    );

    if (action) q = query(q, where("action", "==", action));
    if (entityType) q = query(q, where("entityType", "==", entityType));
    if (userId) q = query(q, where("userId", "==", userId));

    if (fromDate)
        q = query(q, where("createdAt", ">=", fromDate));

    if (toDate)
        q = query(q, where("createdAt", "<=", toDate));

    if (lastDoc)
        q = query(q, startAfter(lastDoc));

    const snapshot = await getDocs(q);

    return {
        rows: snapshot.docs.map((d) => ({ id: d.id, ...d.data() })),
        lastDoc: snapshot.docs[snapshot.docs.length - 1],
    };
};
